import PurpleTab from "root/s360components/PurpleTab";
import NewsTable from "root/s360components/Tables/NewsTable";
import AttendanceSummaryTable from "root/s360components/Tables/AttendanceSummaryTable";
import React from "react";

const DashboardNewsTable = ({school_id}) =>
{
    return (

        <div className='column-wrapper'>
            <PurpleTab title='NEWS'>
                <div className='news-table'>
                    <NewsTable school_id={school_id}></NewsTable>
                </div>
            </PurpleTab>
        </div>
    )
}

export default DashboardNewsTable;